import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { KeepTogether, Section, SectionNumberingProvider, SigningBlock, TemplateDocument, TemplateFooter, TemplateLetterhead, } from '../../../atoms/index.js';
import { SAMTYCKE_DESCRIPTION, SAMTYCKE_TEXT, SHARED_SAMPLE_VALUES, SHARED_SECTION_DEFS, SamtyckeSharedBody, buildSharedFields, } from '../../samtycke_sarskilda_bilaga/shared.js';
export const metadata = {
    sections: [...SHARED_SECTION_DEFS, { ref: 'samtycke', title: 'Samtycke' }],
    templateKey: 'samtycke_sarskilda_avtal',
    version: 'v1',
    category: 'Övriga avtal',
    title: 'Samtycke till behandling av särskilda kategorier av personuppgifter · Version 2026',
    shortTitle: 'Samtycke särskilda kategorier',
    formNumber: 'Formulär R-24',
    preamble: 'Hyresgästens samtycke till behandling av särskilda kategorier av personuppgifter (GDPR artikel 9).',
    description: SAMTYCKE_DESCRIPTION +
        '\n\nVem undertecknar: hyresgästen och hyresvärden. Skickas via Scrive.\n\n' +
        'Ska samtycket i stället bifogas ett hyresavtal och signeras tillsammans med det — använd bilagan "Samtycke särskilda kategorier (bilaga)" från avtalets Bilagor-flik i stället.',
    status: 'active',
    signingMode: 'scrive',
    signingPlacementAnchors: 'per-party-label',
    partySlots: [
        {
            id: 'lessee',
            label: 'Hyresgäst',
            role: 'lessee',
            ordinal: 0,
            required: true,
            signs: true,
        },
        {
            id: 'lessor',
            label: 'Hyresvärd',
            role: 'lessor',
            ordinal: 0,
            required: true,
            signs: true,
        },
    ],
};
export const variableSchema = buildSharedFields('standalone');
export const sampleValues = SHARED_SAMPLE_VALUES;
export function Letterhead() {
    return (_jsx(TemplateLetterhead, { title: metadata.title, formNumber: metadata.formNumber }));
}
export function PageFooter() {
    return _jsx(TemplateFooter, { formNumber: metadata.formNumber });
}
export function Body(props) {
    const { values, mode, signatories } = props;
    return (_jsxs(SectionNumberingProvider, { sections: metadata.sections ?? [], values: values, mode: mode, children: [_jsx("p", { className: "mb-4 italic text-stone-600", children: metadata.preamble }), _jsx(SamtyckeSharedBody, { ...props }), _jsx(KeepTogether, { children: _jsxs(Section, { sectionRef: "samtycke", title: "Samtycke", children: [_jsx("p", { className: "mb-6 text-[10.5px] leading-relaxed text-stone-700", children: SAMTYCKE_TEXT }), _jsx(SigningBlock, { parties: [
                                { label: 'Hyresgäst', role: 'lessee', ordinal: 0 },
                                { label: 'Hyresvärd', role: 'lessor', ordinal: 0 },
                            ], signatories: signatories })] }) })] }));
}
export function Component(props) {
    return (_jsx(TemplateDocument, { header: _jsx(Letterhead, {}), footer: _jsx(PageFooter, {}), children: _jsx(Body, { ...props }) }));
}
//# sourceMappingURL=index.js.map